<template>
  <div class="example-drag flex justify-center h-100 w-100">
    <div class="w-100 h-100">
      <div class="w-100 h-100">
        <div v-show="loading" class="mv2 flex justify-center items-center h-100 w-100">
          <clip-loader :loading="true" :color="color" :size="size"></clip-loader>
        </div>
        <div class="ph5-l flex flex-column justify-center items-center">
          <div class="flex flex-wrap w-100 justify-center">
            <div>
              <upload-image class="ma3" v-if="files[0] || track.id" @uploadFinished="handleUploadFinished" @uploadStart="loadingPicture = true" path="/tracks/upload/picture" :picturePath="picture" :trackEdit="true"/>
              <div class="justify-center" v-if="files[0] || track.id">
                <span class="errorText f7 ph3 ptr" v-if="$v.track.picture.$error && !$v.track.picture.required">{{ $t("error.pictureRequired")}}</span>
              </div>
            </div>
            <div class="w-third-l w-100 w-50-m f6">
              <div class="w-100 ph2-ns">
                <input class="w-100 mv2 block ph1 pv2 input" :class="{error: $v.track.title.$error}"
                      @blur="$v.track.title.$touch" v-model="track.title" name="title"
                      :placeholder="$t('tracks.editTrack.namePlaceholder')">
                <span class="errorText f7"
                      v-if="$v.track.title.$error && !$v.track.title.required">{{ $t("error.trackNameRequired")}}</span>
              </div>
                  <div>
                    <select class="w-100 mv2 mh2-ns block ph1 pv2 input" :class="{error: $v.track.id_music_type.$error}"
                            @blur="$v.track.id_music_type.$touch"
                            @change="filterChildrensGenres()"
                            v-model="mainGenreSelected" id="id_music_type">
                      <option value="" selected>Género</option>
                      <option v-for="genre in genresMain" :track-by="genre.id" :key="genre.id"
                              :value="genre.id">{{genre.name}}
                      </option>
                    </select>
                    <select v-if="mainGenreSelected && isOthers === false" class="w-100 mv2 mh2-ns block ph1 pv2 input" :class="{error: $v.track.id_music_type.$error}"
                            @blur="$v.track.id_music_type.$touch"
                            @change="otherSelected()"
                            v-model="track.id_music_type" id="id_music_type">
                      <option value="" selected>Subgénero</option>
                      <option v-for="genre in childrensGenres" :track-by="genre.id" :key="genre.id"
                              :value="genre.id">{{genre.name}}
                      </option>
                    </select>
                    <span class="errorText f7"
                          v-if="$v.track.id_music_type.$error && !$v.track.id_music_type.required">{{ $t("error.genreRequired")}}</span>
                  </div>
                  <div v-if="isOthersChildren === true || isOthers === true" class="w-100 ph2-ns">
                    <textarea class="w-100 mv2 block ph1 pv2" rows="4" v-model="track.recommendedGenre" type="text" name="tags"
                              :placeholder="$t('tracks.editTrack.recommendedPlaceHolder')"></textarea>
                  </div>
                  <div >
                    <input class="w-100 mv2 block ph1 pv2 input" :class="{error: $v.track.min_price.$error}"
                          @blur="$v.track.min_price.$touch" v-model="track.min_price" name="min_price"
                          :placeholder="$t('tracks.minPrice')">
                    <span class="errorText f7"
                          v-if="$v.track.min_price.$error && !$v.track.min_price.required">{{ $t("error.minPriceRequired")}}</span>
                          <span class="errorText f7"
                          v-if="$v.track.min_price.$error && !$v.track.min_price.minValue">{{ $t("error.minPriceValue")}}</span>
                  </div>
              <div class="w-100 ph2-ns">
                <textarea class="w-100 mv2 block ph1 pv2" rows="4" v-model="track.tags" type="text" name="tags"
                          :placeholder="$t('tracks.editTrack.tagsPlaceholder')"></textarea>
              </div>
              <div class="w-100 ph2-ns">
                <!-- <textarea class="w-100 mv2 block ph1 pv2" rows="4" v-model="track.credits" type="text" name="credits"
                          :placeholder="$t('tracks.editTrack.creditsPlaceholder')"></textarea> -->
                <EditorCK :placeholder="$t('tracks.editTrack.creditsPlaceholder')"
                :credits="track.credits"
                @content-change="handleContentChange" />
              </div>

            </div>
            <div v-show="!files.length" class="pt4 ph4 pb2 w-30">
              <h4 class="tc textColor">{{ $t("tracks.newTrack.dropSelectTrack")}}</h4>
              <label for="file textColor" class="flex justify-center pa3 pointer">
                <font-awesome-icon class="iconColor pa2 white" icon="upload" size="6x"/>
              </label>
              <div class="flex justify-center pv3">
                <file-upload
                  class="btn w5 pointer textColor"
                  :post-action="url"
                  :headers="postFileHeaders"
                  extensions="mp3"
                  :drop="!files.length"
                  v-model="files"
                  ref="upload"
                  @input-file="inputFile"
                  @input-filter="inputFilter">
                  {{ $t("tracks.newTrack.selectFile")}}
                </file-upload>
              </div>
              <span class="errorText f7 ph3 ptr" v-if="!fileValidator">{{ $t("error.trackFileRequired")}}</span>

              <div class="w-100 ph2-ns lwta">
                <input class="w-100 mv2 block ph1 pv2 input" :class="{error: !$v.track.iswc.minLength || !$v.track.iswc.maxLength}"
                      @blur="$v.track.iswc.$touch"
                      v-model="track.iswc" name="iswc"
                      :placeholder="$t('tracks.editTrack.iswcCode')">
                <span class="errorText f7"
                    v-if="!$v.track.iswc.minLength || !$v.track.iswc.maxLength"  >{{ $t("error.iswcErrorCode")}}</span>
              </div>

            </div>
            <div v-show="$refs.upload && $refs.upload.dropActive" class="drop-active">
              <h3 class="textColor">{{ $t("tracks.newTrack.dropMessage")}}</h3>
            </div>
            <div v-if="files[0] !== undefined" class="flex flex-column justify-center items-center w4 ma3">
              <circle-progress :percent="parseFloat(files[0].progress)" ref="circleProgress" :fill="circleFill"
                              emptyFill="#f4f3f4"></circle-progress>
              <p class="textColor" v-show="files[0].progress < 100">{{ $t("app.loading")}}</p>
              <p class="textColor" v-show="files[0].progress == 100">{{ $t("tracks.editTrack.completed")}}</p>
            </div>
          </div>
          <div class="flex flex-wrap mv3 mh3 ba br2 b--light-silver w-75-l">
            <div class="f6 ph3 w-50-ns">
              <p class="b textColor">{{ $t("tracks.licenses.features") }}</p>
              <p class="mt0 b textColor">{{ $t("tracks.licenses.questions.1.title") }}</p>
              <div class="flex-ns justify-start items-center">
                <label class="ma2 textColor"><input name="adaptationCondition" v-model="adaptationCondition" type="radio" :value="0" checked>
                  {{ $t("tracks.licenses.questions.1.options.1") }}</label>
                <label class="ma2 textColor"><input name="adaptationCondition" v-model="adaptationCondition" type="radio" :value="1">
                  {{ $t("tracks.licenses.questions.1.options.2") }}</label>
                <label class="ma2 textColor"><input name="adaptationCondition" v-model="adaptationCondition" type="radio" :value="2">
                  {{ $t("tracks.licenses.questions.1.options.3") }}</label>
              </div>
              <p class="mt0 b textColor">{{ $t("tracks.licenses.questions.2.title") }}</p>
              <div class="flex-ns justify-start items-center">
                <label class="ma2 textColor"><input name="commercialCondition" v-model="commercialCondition" type="radio" :value="0" checked>
                  {{ $t("tracks.licenses.questions.2.options.1") }}</label>
                <label class="ma2 textColor"><input name="commercialCondition" v-model="commercialCondition" type="radio" :value="1">
                  {{ $t("tracks.licenses.questions.2.options.2") }}</label>
              </div>
            </div>
            <div class="f6 ph3 w-100 w-50-ns textColor">
              <p class="b textColor">{{ $t("tracks.licenses.selected") }}</p>
              <p class="textColor" v-if="actualLicense">{{actualLicense.titulo}}</p>
              <img v-show="licenseIcon" :src="licenseIcon" :alt="actualLicense.titulo">
              <p class="textColor">{{actualLicense.descripcion}}</p>
            </div>
          </div>
          <div class="pt4 ph4 pb2 w-50-l w-100">
            <p class="f7 tc textColor"><span class="b">{{ $t("tracks.newTrack.important")}}</span>{{ $t("tracks.newTrack.info")}} </p>
            <p class="f7 b tc textColor">{{ $t("tracks.newTrack.question1")}}</p>
            <p class="f7 mt0 tc textColor">{{ $t("tracks.newTrack.answer1")}}</p>
            <p class="f7 b tc textColor">{{ $t("tracks.newTrack.question2")}}</p>
            <p class="f7 mt0 tc textColor">{{ $t("tracks.newTrack.answer2")}}</p>
          </div>
          <div class="flex justify-center textColor">
            <button class="w4 block mv2 pointer btn dim b f5 fw4 textColor" :class="{disabled: buttonDisabled}"
                    :disabled="buttonDisabled"
                    @click.prevent="edit()">
              <span v-show="!loadingEdition">{{ files[0] ? $t("tracks.newTrack.button") : $t("app.save") }}</span>
              <div v-show="loadingEdition" class="flex justify-center">
                <clip-loader :loading="true" :color="color" :size="smallSize"></clip-loader>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FileUpload from 'vue-upload-component'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import consts from '@/consts'
import auth from '@/auth'
import TrackEdit from './TrackEdit.vue'
import { mapGetters, mapActions } from 'vuex'

import CircleProgress from '@/components/charts/CircleProgress.vue'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import {required, minLength, maxLength} from 'vuelidate/lib/validators'
import minValue from 'vuelidate/lib/validators/minValue'
import UploadImage from '@/components/UploadImage.vue'
import EditorCK from '../textEditor/EditorCK.vue'

export default {
  name: 'track-new',
  data () {
    return {
      files: [],
      fileValidator: true,
      color: '#808080',
      size: '30px',
      smallSize: '15px',
      circleFill: {gradient: ['#272727']},
      track: {
        title: '',
        id_music_type: '',
        tags: '',
        picture: '',
        id_lisense: 0,
        min_price: null,
        recommendedGenre: '',
        iswc: null,
        credits: ''
      },
      isSaving: false,
      loadingPicture: false,
      canEdit: false,
      isOthers: false,
      isOthersChildren: false,
      mainGenreSelected: '',
      childrensGenres: []
    }
  },
  components: {
    FileUpload,
    FontAwesomeIcon,
    TrackEdit,
    UploadImage,
    CircleProgress,
    ClipLoader,
    EditorCK
  },
  created () {
    if (this.userPromise) {
      // wait until user promise is resolved
      this.userPromise.then(() => {
        if (this.isSubscribed) {
          this.setTrackUploaded(false)
          this.setPreventLogout(true)
          this.resetError()
          this.getGenresMain().catch((e) => {
            this.redirectHome(e.message)
          })
          if (this.licenses.length === 0) {
            this.getLicenses().then(() => {
              this.setActualLicense()
            }).catch((e) => {
              this.redirectHome(e.message)
            })
          }
          if (!this.isNewTrack) {
            this.getTrack(this.$route.params.id).then((res) => {
              if (res.canEdit) {
                this.canEdit = true
                this.track = res.track
                this.setLicenseValues(this.track.id_lisense)
                this.setActualLicense()
              } else {
                this.redirectHome(this.$t('app.notAllowed'))
              }
            }).catch((e) => {
              this.redirectHome(e.message)
            })
          } else {
            this.resetLicense()
            /*
            if (this.file === undefined) {
              this.redirectHome(this.$t('tracks.newTrack.trackError'))
            }
            */
          }
        } else {
          // user is not subscribed
          this.redirectHome(this.$t('app.notAllowed'))
        }
      }).catch(() => {
        // user promise was rejected
        this.redirectHome(this.$store.getters['user/error'])
      })
    } else {
      // user is not logged in
      this.redirectHome(this.$t('app.notAllowed'))
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isTrackUploaded || (!this.files.length) || !this.isLoggedIn ||
      (this.files.length && this.userConfirm())) {
      next()
    } else {
      next(false)
    }
  },
  computed: {
    ...mapGetters('track', [
      'genresMain',
      'genres',
      'error',
      'isTrackUploaded'
    ]),
    ...mapGetters('license', [
      'actualLicense',
      'licenses'
    ]),
    ...mapGetters('user', [
      'isLoggedIn',
      'isSubscribed',
      'userPromise',
      'user'
    ]),
    url () {
      return consts.API_BASE_URL + '/tracks/upload/file'
    },
    postFileHeaders: function () {
      return auth.getHeader()
    },
    adaptationCondition: {
      get () {
        return this.$store.state.license.adaptationCondition
      },
      set (value) {
        this.setAdaptationCondition(value)
      }
    },
    commercialCondition: {
      get () {
        return this.$store.state.license.commercialCondition
      },
      set (value) {
        this.setCommercialCondition(value)
      }
    },
    picture () {
      if (this.track && this.track.picture) {
        return consts.MEDIA_BASE_URL + this.track.path + this.track.picture
      }
    },
    licenseIcon () {
      return (this.track.actualLicense) ? 'static' + this.actualLicense.icon : ''
    },
    buttonDisabled () {
      if (this.file !== undefined) {
        return this.loadingPicture || this.file.progress < 100 || this.loadingEdition
      } else {
        return this.loadingPicture || this.loadingEdition
      }
    },
    loading () {
      return (this.$loading.isLoading('track getGenresMain') || this.$loading.isLoading('license getLicenses') || this.$loading.isLoading('getTrack')) || (!this.isNewTrack && !this.canEdit)
    },
    loadingEdition () {
      return this.$loading.isLoading('track editTrack')
    },
    isNewTrack () {
      return !(this.$route.params.id)
    }
  },
  methods: {
    ...mapActions('track', [
      'getGenresMain',
      'editTrack',
      'setTrackUploaded',
      'resetError',
      'getTrack'
    ]),
    ...mapActions('license', [
      'getLicenses',
      'setLicenseValues',
      'setActualLicense',
      'setAdaptationCondition',
      'setCommercialCondition',
      'resetLicense'
    ]),
    ...mapActions('user', [
      'setPreventLogout'
    ]),
    edit () {
      if (this.files.length === 0) {
        this.fileValidator = false
        return
      }
      if (!this.$v.$invalid) {
        if ((this.files[0] === undefined) || ((this.files[0] !== undefined) && this.files[0].response.status === 'ok')) {
          if (!this.disable) {
            this.track.id = ((this.files[0] !== undefined) ? this.files[0].response.data.track_id : this.track.id)
            this.track.new_release = this.isNewTrack
            this.editTrack(this.track).then(() => {
              this.$store.dispatch('track/setTrackUploaded', true)
              if (this.isNewTrack) {
                this.$toasted.show(this.$t('tracks.newTrack.uploaded'), {type: 'success'})
                this.$router.push('/discover')
              } else {
                this.$toasted.show(this.$t('tracks.editTrack.uploaded'), {type: 'success'})
                this.isSaving = true
                this.$router.push({ name: 'my-tracks' })
              }
            }).catch((e) => {
              this.$toasted.show(this.error, {
                type: 'error'
              })
            })
          } else {
            this.$toasted.show(this.$t('tracks.newTrack.imageError'), {
              type: 'error'
            })
          }
        } else {
          this.$toasted.show(this.$t('error.trackUpload'), {
            type: 'error'
          })
        }
      } else {
        this.$v.$touch()
      }
    },
    handleUploadFinished (picture) {
      if (picture === '') {
        this.track.picture = '/static/assets/Img_comodines_Beathey_Playlist.jpg'
      } else {
        this.track.picture = picture
      }
      this.loadingPicture = false
    },
    redirectHome (message) {
      this.$router.push({path: '/home'})
      this.$toasted.show(message, { type: 'error' })
    },
    userConfirm () {
      return window.confirm(this.$t('tracks.newTrack.leaveConfirmation'))
    },
    filterChildrensGenres () {
      this.isOthers = false
      this.track.id_music_type = ''
      if (this.mainGenreSelected !== '') {
        this.genresMain.forEach(item => {
          if (item.id === this.mainGenreSelected) {
            if (item.name !== 'OTHERS') {
              this.childrensGenres = item.children.sort(function (a, b) {
                if (a.name > b.name) {
                  return 1
                }
                if (a.name < b.name) {
                  return -1
                }
                // a must be equal to b
                return 0
              })
            } else {
              this.isOthers = true
              this.track.id_music_type = item.children[0].id
            }
          }
        })
      }
    },
    otherSelected () {
      this.isOthersChildren = false
      this.childrensGenres.forEach(item => {
        if (item.id === this.track.id_music_type) {
          if (item.name === 'OTHERS') {
            this.isOthersChildren = true
          }
        }
      })
    },
    inputFile: function (newFile, oldFile) {
      // auto start
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.upload.active) {
          this.$refs.upload.active = true
        }
      }
    },
    inputFilter: function (newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Filter mp3
        if (!/\.(mp3)$/i.test(newFile.name)) {
          this.$toasted.show(this.$t('tracks.newTrack.extensionMessage'), {type: 'error'})
          return prevent()
        }
      }
    },
    handleContentChange (content) {
      this.track.credits = content
    }
  },
  watch: {
    adaptationCondition () {
      this.setActualLicense()
    },
    commercialCondition () {
      this.setActualLicense()
    }
  },
  validations: {
    track: {
      title: {
        required
      },
      id_music_type: {
        required
      },
      picture: {
        required
      },
      min_price: {
        required,
        minValue: minValue(1)
      },
      iswc: {
        minLength: minLength(13),
        maxLength: maxLength(13)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';
  .example-drag .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }
  .example-drag .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }

  .example-drag .drop-active {
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    position: fixed;
    z-index: 9999;
    opacity: .6;
    text-align: center;
    background: #000;
  }

  .example-drag .drop-active h3 {
    margin: -.5em 0 0;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    font-size: 40px;
    color: #fff;
    padding: 0;
  }

  .input {
    background-color: $background-color;
  }

  .disabled {
    opacity: 0.5 !important;
    cursor: not-allowed;
  }

  select, textarea {
    color: $text-color;
    background-color: $background-color;
  }

  .image-container {
    background-position: center center;
  }

  .ptr {
    margin-left: 20px;
  }

  .lwta {
    margin-top: 33px;
  }
</style>



// WEBPACK FOOTER //
// src/components/tracks/TrackNew.vue